import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { injectExternalList } from 'helpers/actions'

export const CustomersRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'customers',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/CustomersContainer').default

      const actions = require('./modules/customers').actions
      const reducer = require('./modules/customers').default

      injectReducer(store, { key: 'customers', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'customers')
  }
})

export const NewCustomerRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'customers/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewCustomerContainer').default

      const reducer = require('./modules/customer').default

      injectReducer(store, { key: 'customer', reducer })
      injectExternalList(store, 'routes')

      cb(null, Container)
    }, 'customers')
  }
})

export const EditCustomerRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'customers/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditCustomerContainer').default

      const actions = require('./modules/customer').actions
      const reducer = require('./modules/customer').default

      injectReducer(store, { key: 'customer', reducer })
      injectExternalList(store, 'routes')

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'customers')
  }
})

export default function (store) {
  return [
    NewCustomerRoute(store),
    EditCustomerRoute(store),
    CustomersRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Customers/index.js